<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="450">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn class="ma-0" depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="confirm_form" data-vv-scope="confirm_form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-icon size="150" :color="type ? typeColors[type] : 'error'" class="">error_outline</v-icon>
              </v-flex>
              <v-flex xs12 text-xs-center headline>
                {{ title ? title : 'Are you sure?' }}
              </v-flex>
              <v-flex xs12 text-xs-center subheading mt-3 v-html="confirmText"></v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" flat @click="dialog = false">Cancel</v-btn>
          <v-btn class="white--text" :color="type ? typeColors[type] : 'error'" @click="confirm()" :loading="loading" :disabled="loading">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: ['confirmDialog', 'confirmText', 'loading', 'type', 'param', 'title'],
  data () {
    return {
      dialog: this.confirmDialog,
      typeColors: {
        delete: 'error',
        warning: 'warning',
        success: 'success'
      }
    }
  },
  watch: {
    confirmDialog: {
      handler () {
        this.dialog = this.confirmDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('confirmDialog', this.dialog)
      }
    }
  },
  methods: {
    confirm () {
      this.$parent.$emit('confirmAction', this.param)
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/confirm-modal/ConfirmModal.vue